import { render, staticRenderFns } from "./Observation.vue?vue&type=template&id=ca03cd3e&scoped=true&"
import script from "./Observation.ts?vue&type=script&lang=ts&"
export * from "./Observation.ts?vue&type=script&lang=ts&"
import style0 from "./Observation.vue?vue&type=style&index=0&id=ca03cd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca03cd3e",
  null
  
)

export default component.exports